// removed by extract-text-webpack-plugin
module.exports = {"title":"_1Oww1oVW1ntHENdtTaOGnu","refreshAll":"_2yfGTuIIGn8uHnNBEy1qj5","searchBox":"_2FwcWP-C0WNKEz8eCXPSrR","search":"_3eP3Xp6ftBxibNtvkxG6Mf","button":"_3EQRifNpbhjdBahX38pl2a","product":"i54Q1dl8_IaPw2QW7JQp0","image":"_2ygsZ80-a60zR3FCrROn49","name":"BlO-phAzmZjub3W1ryNak","price":"_1V9rB4ckLC9Bl5nCAkbvxp","stock":"_1JpKw9xJMXfuxWdW090mEH","location":"ykOseh6-qJBw3ca7pt-0B"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Products/style.scss
// module id = 1240
// module chunks = 0